module.exports = __webpack_public_path__ + "21798a2ffe0455f92974515443678cac.png";